'use client';

import type { FC, ReactNode } from 'react';
import { WikiLink as Link } from './WikiLink';
import { useWikiGoal } from './useWikiGoal';
import { useNavigation } from '../../../contexts/NavigationContext';
import { useRuntime } from '../../../runtime/RuntimeContext';
import { wikiHref } from '../wikiText';

import type { Language } from '../../../i18n/types';

interface WikiShotCaseLinkProps {
  lang: Language;
  slug: string;
  className?: string;
  children: ReactNode;
}

export const WikiShotCaseLink: FC<WikiShotCaseLinkProps> = ({ lang, slug, className, children }) => {
  const reachGoal = useWikiGoal();
  const inMiniApp = useRuntime() === 'tma';
  const { navigate } = useNavigation();
  return (
    <Link
      href={wikiHref(lang, `/cases/${slug}`)}
      className={className}
      onClick={(event) => {
        reachGoal('wiki_shot_click');
        // WHY: в Mini App кейс — экран стека, а не адрес: переход по адресу ушёл бы на `/` и сбросил приложение
        if (inMiniApp) {
          event.preventDefault();
          navigate('case-details', { caseId: slug });
        }
      }}
    >
      {children}
    </Link>
  );
};
